import { useCallback, useEffect, useRef, useState } from 'react'

export const useStatusMsg = () => {
  const [statusMsg, setStatusMsgState] = useState(null)
  const timerRef = useRef(null)

  const setStatusMsg = useCallback((msg) => {
    if (timerRef.current) clearTimeout(timerRef.current)
    setStatusMsgState(msg)
    timerRef.current = setTimeout(() => setStatusMsgState(null), 2000)
  }, [])

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current) }, [])

  return { statusMsg, setStatusMsg }
}
